// Components
export const COMPONENT_ACTIVE_SERVER = "component_active_server";
export const COMPONENT_ALTERNATIVE_FORMULAS = "component_alternative_formulas";
export const COMPONENT_AUTOTASKS_SETTINGS = "component_autotasks_settings";
export const COMPONENT_BARCODE_SCAN_MODAL = "component_barcode_scan_modal";
export const COMPONENT_BARCODE_TEST_MODAL = "component_barcode_test_modal";
export const COMPONENT_BUG_REPORT = "component_bug_report";
export const COMPONENT_BUILDING_SITE_PANEL = "component_building_site_panel";
export const COMPONENT_CANISTER_BARCODES = "component_canister_barcodes";
export const COMPONENT_CANISTER_BARCODES_MODAL = "component_canister_barcodes_modal";
export const COMPONENT_CANISTER_REFILL_HISTORY_MODAL = "component_canister_refill_history_modal";
export const COMPONENT_CANISTER_FILLING = "component_canister_filling";
export const COMPONENT_CANISTERS_TAB = "component_canisters_tab";
export const COMPONENT_CLIENT_IDENTIFIER = "component_client_identifier";
export const COMPONENT_CLIENT_SERVER_CONNECTION = "component_client_server_connection";
export const COMPONENT_COLOR_SEARCH_TAB = "component_color_search_tab";
export const COMPONENT_COLOR_TAB = "component_color_tab";
export const COMPONENT_COLORANT_CONSUMPTION = "component_colorant_consumption";
export const COMPONENT_COLORANT_PANEL = "component_colorant_panel";
export const COMPONENT_COLORANT_REFILL_HISTORY = "component_colorant_refill_history";
export const COMPONENT_COLORANT_STOCK_MODAL = "component_colorant_stock_modal";
export const COMPONENT_CUSTOM_FORMULA_TAB = "component_custom_formula_tab";
export const COMPONENT_CUSTOMERS_PANEL = "component_customers_panel";
export const COMPONENT_CUSTOMERS_TAB = "component_customers_tab";
export const COMPONENT_DATABASE_LIST = "component_database_list";
export const COMPONENT_DATABASE_MODAL = "component_database_modal";
export const COMPONENT_DEBUG_MODAL = "component_debug_modal";
export const COMPONENT_DELETE_IMPORTED_DATA = "component_delete_imported_data";
export const COMPONENT_DISPENSING_LOGIC = "component_dispensing_logic";
export const COMPONENT_DISPENSING_NOTES_PANEL = "component_dispensing_notes_panel";
export const COMPONENT_DISPENSING_SETTINGS = "component_dispensing_settings";
export const COMPONENT_DRIVER_SETTINGS = "component_driver_settings";
export const COMPONENT_EXPORT_LOCAL_DB = "component_export_local_db";
export const COMPONENT_EXPORT_SETTINGS = "component_export_settings";
export const COMPONENT_EXPORT_STATIC_SQL = "component_export_static_sql";
export const COMPONENT_FAVORITES_TAB = "component_favorites_tab";
export const COMPONENT_FORMULA_MASTER_PRODUCT = "component_formula_master_product";
export const COMPONENT_FORMULA_STATUS_PANEL = "component_formula_status_panel";
export const COMPONENT_FORMULA_TAB = "component_formula_tab";
export const COMPONENT_HIDE_ITEMS_MODAL = "component_hide_items_modal";
export const COMPONENT_HISTORICAL_FORMULAS = "component_historical_formulas";
export const COMPONENT_HISTORY_OF_ORDERS_TAB = "component_history_of_orders_tab";
export const COMPONENT_CHANGELOG = "component_changelog";
export const COMPONENT_CHEAPER_COLORS_MODAL = "component_cheaper_colors_modal";
export const COMPONENT_IMPORT_DATA = "component_import_data";
export const COMPONENT_IMPORT_SETTINGS = "component_import_settings";
export const COMPONENT_INTERNAL_NOTES_PANEL = "component_internal_notes_panel";
export const COMPONENT_LICENSE_IDENTIFICATION = "component_license_identification";
export const COMPONENT_LICENSE_STATUS = "component_license_status";
export const COMPONENT_LICENSE_SUPPLIER = "component_license_supplier";
export const COMPONENT_MACHINE_DIALOG = "component_machine_dialog";
export const COMPONENT_MACHINE_INFO = "component_machine_info";
export const COMPONENT_MACHINE_OPTIONS = "component_machine_options";
export const COMPONENT_MACHINE_REGISTRATION = "component_machine_registration";
export const COMPONENT_MACHINE_SETTINGS = "component_machine_settings";
export const COMPONENT_MATCHING_TAB = "component_matching_tab";
export const COMPONENT_MY_ORDERS_TAB = "component_my_orders_tab";
export const COMPONENT_ORDER_NOTIFICATION_MODAL = "component_order_notification_modal";
export const COMPONENT_PARTIAL_UPDATES_MODAL = "component_partial_updates_modal";
export const COMPONENT_POS_INFO = "component_pos_info";
export const COMPONENT_PRICE_PANEL = "component_price_panel";
export const COMPONENT_QUICK_TINT_MODAL = "component_quick_tint_modal";
export const COMPONENT_QUALITY_CONTROL_MODAL = "component_quality_control_modal";
export const COMPONENT_RCC_CONNECTION = "component_rcc_connection";
export const COMPONENT_REFILLING_LOGIC = "component_refilling_logic";
export const COMPONENT_REGISTRATION = "component_registration";
export const COMPONENT_RESTORE_SETTINGS = "component_restore_settings";
export const COMPONENT_SERVER_PLUGINS = "component_server_plugins";
export const COMPONENT_SERVICE_TICKET_MODAL = "component_service_ticket_modal";
export const COMPONENT_SMART_PURGE_RULES = "component_smart_purge_rules";
export const COMPONENT_SPECTRO_DIALOG = "component_spectro_dialog";
export const COMPONENT_SPECTRO_SETTINGS = "component_spectro_settings";
export const COMPONENT_SPECTRO_TAB = "component_spectro_tab";
export const COMPONENT_STATISTICS_TAB = "component_statistics_tab";
export const COMPONENT_TAB_BAR_PANEL = "component_tab_bar_panel";
export const COMPONENT_TEMPLATE_HINT = "component_template_hint";
export const COMPONENT_TICKETING_TAB = "component_ticketing_tab";
export const COMPONENT_TO_DISPENSE_TAB = "component_to_dispense_tab";
export const COMPONENT_UPDATE_OPTIONS = "component_update_options";

// Top level menu items
export const MENU = "menu";
export const MENU_SIMPLIFIERS = "menu_simplifiers";
export const MENU_MAINTENANCE = "menu_maintenance";
export const MENU_SERVICE_ACTIONS = "menu_service_actions";
export const MENU_STATISTICS = "menu_statistics";
export const MENU_MACHINE_AND_DEVICES = "menu_machine_and_devices";
export const MENU_DEVICES = "menu_devices";
export const MENU_MACHINE_MANAGEMENT = "menu_machine_management";
export const MENU_MACHINE_SETTINGS = "menu_machine_settings";
export const MENU_SPECTRO_SETTINGS = "menu_spectro_settings";
export const MENU_PRINT_SETTINGS = "menu_print_settings";
export const MENU_RCC_CONNECTION = "menu_rcc_connection";
export const MENU_SETTINGS = "menu_settings";
export const MENU_DATABASE = "menu_database";
export const MENU_DATABASE_CONNECTION = "menu_database_connection";
export const MENU_DATABASE_IMPORT = "menu_database_import";
export const MENU_SERVER_CONNECTION = "menu_server_connection";
export const MENU_IMPORT_CUSTOM_DATA = "menu_import_custom_data";
export const MENU_FILE_TRANSFER = "menu_file_transfer";
export const MENU_SERVER_PLUGINS = "menu_server_plugins";
export const MENU_LICENSE = "menu_license";
export const MENU_LICENSE_DATA = "menu_license_data";
export const MENU_UPDATE = "menu_update";
export const MENU_BUG_REPORT = "menu_bug_report";

// Submenu items
export const SUBMENU_AUTOTASKS = "submenu_autotasks";
export const SUBMENU_CANISTER_SETTINGS = "submenu_canister_settings";
export const SUBMENU_COLORANT_CONSUMPTION = "submenu_purge_statistics";
export const SUBMENU_CUSTOM_FORMULA = "submenu_custom_formula";
export const SUBMENU_DISPENSING_SETTINGS = "submenu_dispensing_settings";
export const SUBMENU_DRIVER_SETTINGS = "submenu_driver_settings";
export const SUBMENU_GENERAL = "submenu_general";
export const SUBMENU_LICENSE_STATUS = "submenu_license_status";
export const SUBMENU_MACHINE_INFO = "submenu_machine_info";
export const SUBMENU_MACHINE_MANAGEMENT = "submenu_machine_management";
export const SUBMENU_POS_INFO = "submenu_pos_info";
export const SUBMENU_REFILL_HISTORY = "submenu_refill_history";
export const SUBMENU_REFILL_SETTINGS = "submenu_refill_settings";
export const SUBMENU_REGISTRATION = "submenu_registration";
export const SUBMENU_SINGLE_ACTIONS = "submenu_single_actions";
export const SUBMENU_SMART_PURGE_RULES = "submenu_smart_purge_rules";

// Menu contents
export const CONTENT_SINGLE_ACTIONS = "content_single_actions";
export const CONTENT_SMART_PURGE_RULES = "content_smart_purge_rules";
export const CONTENT_AUTOTASKS = "content_autotasks";
export const CONTENT_COLORANT_CONSUMPTION = "content_purge_statistics";
export const CONTENT_REFILL_HISTORY = "content_refill_history";
export const CONTENT_MACHINE_INFO = "content_machine_info";
export const CONTENT_MACHINE_MANAGEMENT = "content_machine_management";
export const CONTENT_DISPENSING_SETTINGS = "content_dispensing_settings";
export const CONTENT_CANISTER_SETTINGS = "content_canister_settings";
export const CONTENT_DRIVER_SETTINGS = "content_driver_settings";
export const CONTENT_REFILL_SETTINGS = "content_refill_settings";
export const CONTENT_SPECTRO_SETTINGS = "content_spectro_settings";
export const CONTENT_PRINT_SETTINGS = "content_print_settings";
export const CONTENT_RCC_CONNECTION = "content_rcc_connection";
export const CONTENT_DATABASE_CONNECTION = "content_database_connection";
export const CONTENT_DATABASE_IMPORT = "content_database_import";
export const CONTENT_SERVER_CONNECTION = "content_server_connection";
export const CONTENT_SERVER_PLUGINS = "content_server_plugins";
export const CONTENT_IMPORT_CUSTOM_DATA = "content_import_custom_data";
export const CONTENT_FILE_TRANSFER = "content_file_transfer";
export const CONTENT_REGISTRATION = "content_registration";
export const CONTENT_POS_INFO = "content_pos_info";
export const CONTENT_LICENSE_STATUS = "content_license_status";
export const CONTENT_UPDATE_OPTIONS = "content_update_options";
export const CONTENT_BUG_REPORT = "content_bug_report";

// Menu content items
export const CONTENT_ITEM_SINGLE_ACTIONS_CANISTERS = "content_item_single_actions_canisters";
export const CONTENT_ITEM_SINGLE_ACTIONS_CAP = "content_item_single_actions_cap";
export const CONTENT_ITEM_SINGLE_ACTIONS_CLEAN = "content_item_single_actions_clean";
export const CONTENT_ITEM_SINGLE_ACTIONS_COMPUTER = "content_item_single_actions_computer";
export const CONTENT_ITEM_SINGLE_ACTIONS_GENERAL = "content_item_single_actions_general";
export const CONTENT_ITEM_SINGLE_ACTIONS_PLUGGER = "content_item_single_actions_plugger";
export const CONTENT_ITEM_SINGLE_ACTIONS_PUNCHER = "content_item_single_actions_puncher";
export const CONTENT_ITEM_SINGLE_ACTIONS_PURGE = "content_item_single_actions_purge";
export const CONTENT_ITEM_SINGLE_ACTIONS_RECIRCULATE = "content_item_single_actions_recirculate";
export const CONTENT_ITEM_SINGLE_ACTIONS_SHELF = "content_item_single_actions_shelf";
export const CONTENT_ITEM_SINGLE_ACTIONS_STIR = "content_item_single_actions_stir";
export const CONTENT_ITEM_MACHINE_OPTIONS = "content_item_machine_options";
export const CONTENT_ITEM_TMC = "content_item_tmc";
export const CONTENT_ITEM_MACHINE_CAN_OPTIONS = "content_item_machine_can_options";
export const CONTENT_ITEM_MACHINE_DISPENSING_OPTIONS = "content_item_machine_dispensing_options";
export const CONTENT_ITEM_MACHINE_BARCODE_REFILL_VALIDATION = "content_item_machine_barcode_refill_validation";
export const CONTENT_ITEM_MACHINE_UFI_CODE = "content_item_machine_ufi_code";
export const CONTENT_ITEM_MACHINE_COLORANT_BATCH_NUMBERS = "content_item_machine_colorant_batch_numbers";
export const CONTENT_ITEM_PRINTER_SETTINGS = "content_item_printer_settings";
export const CONTENT_ITEM_TEMPLATE_SETTINGS = "content_item_template_settings";
export const CONTENT_ITEM_PRINT_OPTIONS = "content_item_print_options";
export const CONTENT_ITEM_CUSTOM_DATA = "content_item_custom_data";
export const CONTENT_ITEM_LOCAL_DATA = "content_item_local_data";
export const CONTENT_ITEM_FILE_TRANSFER_EXPORT = "content_item_file_transfer_export";
export const CONTENT_ITEM_FILE_TRANSFER_IMPORT = "content_item_file_transfer_import";
export const CONTENT_ITEM_ONE_TIME_IMPORT = "content_item_one_time_import";

// Top level settings menu items
export const MENU_SETTIGNS = "menu_settings";
export const MENU_INTERFACE_SETTIGNS = "menu_interface_settings";
export const MENU_ADVANCED_SETTIGNS = "menu_advanced_settings";
export const MENU_PRICE_SETTIGNS = "menu_price_settings";
export const MENU_USER_MANAGEMENT = "menu_user_management";

// Settings submenu items
export const SUBMENU_ENVIRONMENTAL_SETTINGS = "submenu_environmental_settings";
export const SUBMENU_SOFTWARE_OPTIONS = "submenu_software_options";
export const SUBMENU_LAYOUT = "submenu_layout";
export const SUBMENU_TABS = "submenu_tabs";
export const SUBMENU_NAVIGATION_ITEMS = "submenu_navigation_items";
export const SUBMENU_FORMULA_SETTINGS = "submenu_formula_settings";
export const SUBMENU_COLOR = "submenu_color";
export const SUBMENU_COLORANT = "submenu_colorant";
export const SUBMENU_COLOR_REPRESENTATION = "submenu_color_representation";
export const SUBMENU_FORMULA_PANELS = "submenu_formula_panels";
export const SUBMENU_AVAILABLE_PRICES = "submenu_available_prices";
export const SUBMENU_COLOR_PANEL = "submenu_color_panel";
export const SUBMENU_QUALITY_CONTROL_SETTINGS = "submenu_quality_control_settings";
export const SUBMENU_QUINT_TINT = "submenu_quick_tint";
export const SUBMENU_MATCHING_SETTINGS = "submenu_matching_settings";
export const SUBMENU_ORDER_SETTINGS = "submenu_order_settings";
export const SUBMENU_SEARCH_SETTINGS = "submenu_search_settings";
export const SUBMENU_LANGUAGE_SETTINGS = "submenu_language_settings";
export const SUBMENU_KEYBOARD_SHORTCUTS = "submenu_keyboard_shortcuts";
export const SUBMENU_HELP_SETTINGS = "submenu_help_settings";
export const SUBMENU_PRICING_OPTIONS = "submenu_pricing_options";
export const SUBMENU_DEFAULT_PRICE_VALUES = "submenu_default_price_values";
export const SUBMENU_MARGIN_SETTING = "submenu_margin_settings";
export const SUBMENU_COLORANT_PRICING = "submenu_colorant_pricing";
export const SUBMENU_PRODUCT_PRICING = "submenu_product_pricing";
export const SUBMENU_PACKAGE_PRICING = "submenu_package_pricing";

// Settings menu contents
export const CONTENT_ENVIRONMENT = "content_environment";
export const CONTENT_VISIBLE_UNITS = "content_visible_units";
export const CONTENT_FORMULA_UNIT = "content_formula_unit";
export const CONTENT_INITIAL_TAB = "content_initial_tab";
export const CONTENT_ADDITIONAL_TAB = "content_additional_tab";
export const CONTENT_POP_UPS = "content_pop_ups";
export const CONTENT_COLOR_SEARCH = "content_color_search";
export const CONTENT_MODIFICATION = "content_modification";
export const CONTENT_COMPETITIVE_SEARCH = "content_competitive_search";
export const CONTENT_QUALITY_CONTROL = "content_quality_control";
export const CONTENT_QUICK_TINT_SORTING = "content_quick_tint_sorting";
export const CONTENT_QUICK_TINT_CLOSING = "content_quick_tint_closing";
export const CONTENT_MATCHING_INFORMATION = "content_matching_information";
export const CONTENT_MATCHING_OPTIONS = "content_matching_options";
export const CONTENT_MATCHING_RESULT = "content_matching_result";
export const CONTENT_ORDER_SEARCH = "content_order_search";
export const CONTENT_GENERAL_SEARCH = "content_general_search";
export const CONTENT_LANGUAGE = "content_language";
export const CONTENT_FORMATTING = "content_formatting";
export const CONTENT_MAIN_PRICE_SETTINGS = "content_main_price_settings";
export const CONTENT_PRICE_CALCULATION = "content_price_calculation";
export const CONTENT_IMPORT_AND_EXPORT_PRICE = "content_import_and_export_price";
export const CONTENT_CURRENCY_SETTINGS = "content_currency_settings";

// Settings menu content items
export const CONTENT_ITEM_DEFAULT_PRICE_VALUES = "content_item_default_price_values";
export const CONTENT_ITEM_MARGIN_SETTINGS = "content_item_margin_settings";
export const CONTENT_ITEM_COLORANT_PRICING = "content_item_colorant_pricing";
export const CONTENT_ITEM_PRODUCT_PRICING = "content_item_product_pricing";
export const CONTENT_ITEM_PACKAGE_PRICING = "content_item_package_pricing";
export const CONTENT_ITEM_LIGHT_AT_STARTUP = "content_item_light_at_startup";
export const CONTENT_ITEM_CURRENCY_SETTINGS = "content_item_currency_settings";
export const CONTENT_ITEM_PRICE_IMPORT = "content_item_price_import";
export const CONTENT_ITEM_PRICE_EXPORT = "content_item_price_export";
export const CONTENT_ITEM_TRANSLATIONS = "content_item_translations";
export const CONTENT_ITEM_USER_MANAGEMENT = "content_item_user_management";

// Settings items
export const SETTINGS_ADDITIONAL_TAB_TYPE = "additional_tab_type";
export const SETTINGS_ALTERNATIVE_FORMULAS_POSITION = "alternative_formulas_position";
export const SETTINGS_AUTO_CLOSE_TAB = "auto_close_tab";
export const SETTINGS_AUTOMATIC_CLIENT_START = "automatic_client_start";
export const SETTINGS_AUTOMATIC_LOGOUT = "automatic_logout";
export const SETTINGS_AUTOMATIC_PRINT = "automatic_print";
export const SETTINGS_BARCODES_ENABLED = "barcodes_enabled";
export const SETTINGS_BLEND_FORMULA_AND_CODE = "settings_blend_formula_and_code";
export const SETTINGS_BUILDING_SITE = "building_site";
export const SETTINGS_COLOR_PREVIEW_AS_IMAGE = "color_preview_as_image";
export const SETTINGS_COLOR_PREVIEW_RESIZABLE = "color_preview_resizable";
export const SETTINGS_CLEANING_TIME = "settings_cleaning_time";
export const SETTINGS_COLOR_TAB_FORMULA_CODE = "color_tab_formula_code";
export const SETTINGS_COLOR_TAB_FORMULA_NAME = "color_tab_formula_name";
export const SETTINGS_COLOR_TAB_COMPATIBLE_ONLY = "color_tab_compatible_only";
export const SETTINGS_COLOR_TAB_NOTE_ICONS = "color_tab_note_icons";
export const SETTINGS_COLOR_TAB_ORDER_BY = "color_tab_order_by";
export const SETTINGS_COLOR_TAB_ROW_COUNT = "color_tab_row_count";
export const SETTINGS_COLOR_TAB_WARNING_ICON = "color_tab_warning_icon";
export const SETTINGS_COLORANT_BATCH_FOR_MULTIPLE_CANS = "check_available_cnt_amounts";
export const SETTINGS_COLORANT_BATCH_NUMBER_LOGIC = "colorant_batch_number_logic";
export const SETTINGS_COMPETITIVE_COLOR_SEARCH = "competitive_color_search";
export const SETTINGS_CUSTOM_BANNER_POSITION = "custom_banner_position";
export const SETTINGS_CUSTOM_CAN_SIZE = "custom_can_size";
export const SETTINGS_CUSTOM_CAN_OPTION = "custom_can_option";
export const SETTINGS_CUSTOM_CAN_SETTINGS_UNIT_GRAV = "custom_can_settings_unit_grav";
export const SETTINGS_CUSTOM_CAN_SETTINGS_UNIT_VOL = "custom_can_settings_unit_vol";
export const SETTINGS_CUSTOM_FORMAT_CURRENCY = "custom_format_currency";
export const SETTINGS_CUSTOM_FORMAT_DATE = "custom_format_date";
export const SETTINGS_CUSTOM_FORMAT_NUMBER = "custom_format_number";
export const SETTINGS_CUSTOM_FORMAT_TIME = "custom_format_time";
export const SETTINGS_CUSTOM_FORMULA_FOR_MASTER_PRODUCT = "custom_formula_for_master_product";
export const SETTINGS_CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT = "custom_formula_for_master_product_default";
export const SETTINGS_CUSTOM_FORMULAS = "custom_formulas";
export const SETTINGS_COLORANT_PANEL_LIMIT = "colorant_panel_limit";
export const SETTINGS_COLORANT_PANEL_ORDER_BY = "colorant_panel_order_by";
export const SETTINGS_CUSTOM_HOME_BUTTON = "settings_custom_home_button";
export const SETTINGS_CUSTOMERS_ENABLED = "customers_enabled";
export const SETTINGS_DELETE_CONFIRMATION = "delete_confirmation";
export const SETTINGS_DISK_SPACE_NOTIFICATION = "disk_space_notification";
export const SETTINGS_DISPENSING_ENABLED = "dispensing_enabled";
export const SETTINGS_DISPENSING_NOTES = "dispensing_notes";
export const SETTINGS_DISPENSING_WITH_ERRORS_ENABLED = "dispensing_with_errors_enabled";
export const SETTINGS_EDIT_COLORANT_ALLOWANCE = "edit_colorant_allowance";
export const SETTINGS_FANDECK_GROUPS = "fandeck_groups";
export const SETTINGS_FILE_TRANSFER = "file_transfer";
export const SETTINGS_FILE_TRANSFER_IN_TASKS = "file_transfer_in_tasks";
export const SETTINGS_FILE_TRANSFER_OUT_TASKS = "file_transfer_out_tasks";
export const SETTINGS_FORMULA_AUTOMATIC_NAMING = "formula_automatic_naming";
export const SETTINGS_FORMULA_CODE = "formula_code";
export const SETTINGS_FORMULA_CODE_PRIMARY = "formula_code_primary";
export const SETTINGS_FORMULA_COLOR_PREVIEW = "formula_color_preview";
export const SETTINGS_FORMULA_MODIFICATION_PANEL = "formula_modification_panel_enabled";
export const SETTINGS_FORMULA_NAME = "formula_name";
export const SETTINGS_FORMULA_NOTES = "formula_notes";
export const SETTINGS_FORMULA_PREVIEW = "formula_preview";
export const SETTINGS_FORMULA_PROPERTIES_POSITION = "formula_properties_position";
export const SETTINGS_FORMULA_STATUS_PANEL = "formula_status_panel_enabled";
export const SETTINGS_FORMULA_UNITS = "formula_units";
export const SETTINGS_FTS = "fts";
export const SETTINGS_GAMMA_MACHINE_SORTING_ORDERS = "intergamma_machine_sorting_orders";
export const SETTINGS_GAMMA_COLOR_FANDECK_WIZARD = "intergamma_color_fandeck_wizard";
export const SETTINGS_GAMMA_ORDER_QUICK_SELECT = "intergamma_order_quick_select";
export const SETTINGS_GAMMA_MODULE = "intergamma_module";
export const SETTINGS_GENERATE_COLOR_PREVIEW = "generate_color_preview";
export const SETTINGS_GDPR_ENABLED = "gdpr_enabled";
export const SETTINGS_HELP = "help";
export const SETTINGS_HISTORICAL_FORMULAS_POSITION = "historical_formulas_position";
export const SETTINGS_IMAGES_SOURCE = "images_source";
export const SETTINGS_INFO_PANEL_RESIZABLE = "info_panel_resizable";
export const SETTINGS_INFO_TYPES = "info_types";
export const SETTINGS_INFO_ITEM_IN_RGB_PREVIEW = "settings_info_item_in_rgb_preview";
export const SETTINGS_INIT_TAB_TYPE = "init_tab_type";
export const SETTINGS_KEYBOARD = "keyboard";
export const SETTINGS_KEYBOARD_SHORTCUTS = "keyboard_shortcuts";
export const SETTINGS_KIOSK = "kiosk";
export const SETTINGS_LIGHT_ENABLED = "light_enabled";
export const SETTINGS_LOCALE = "locale";
export const SETTINGS_LOCK_COMPUTER = "lock_pc";
export const SETTINGS_MASTER_PRODUCT_SIBLINGS_TABLE = "master_product_siblings_table";
export const SETTINGS_MATCHING_INFO_CR = "matching_info_cr";
export const SETTINGS_MATCHING_INFO_DELTA_E1 = "matching_info_delta_e1";
export const SETTINGS_MATCHING_INFO_DELTA_E2 = "matching_info_delta_e2";
export const SETTINGS_MATCHING_INFO_DELTA_E3 = "matching_info_delta_e3";
export const SETTINGS_MATCHING_INFO_DIN = "matching_info_din";
export const SETTINGS_MATCHING_INFO_LRV = "matching_info_lrv";
export const SETTINGS_MATCHING_INFO_RMS = "matching_info_rms";
export const SETTINGS_MATCHING_OPTIONS_COLORANTS = "matching_options_colorants";
export const SETTINGS_MATCHING_OPTIONS_COLORFILE = "matching_options_colorfile";
export const SETTINGS_MATCHING_OPTIONS_SORT_RESULTS = "matching_options_sort_results";
export const SETTINGS_MATCHING_ROW_COUNT = "matching_row_count";
export const SETTINGS_MATCHING_TABLE_BASE = "matching_table_base";
export const SETTINGS_MATCHING_TABLE_COLORANTS = "matching_table_colorants";
export const SETTINGS_MATCHING_TABLE_CR = "matching_table_cr";
export const SETTINGS_MATCHING_TABLE_DELTA_E1 = "matching_table_delta_e1";
export const SETTINGS_MATCHING_TABLE_DELTA_E2 = "matching_table_delta_e2";
export const SETTINGS_MATCHING_TABLE_DELTA_E3 = "matching_table_delta_e3";
export const SETTINGS_MATCHING_TABLE_DIN = "matching_table_din";
export const SETTINGS_MATCHING_TABLE_LRV = "matching_table_lrv";
export const SETTINGS_MATCHING_TABLE_PRICE = "matching_table_price";
export const SETTINGS_MATCHING_TABLE_RMS = "matching_table_rms";
export const SETTINGS_MAX_TOLERANCE_FOR_COMPETITIVE_COLORS = "max_tolerance_for_competitive_colors";
export const SETTINGS_MORE_INFO_INTERNAL = "more_info_internal";
export const SETTINGS_NAVIGATION_ITEMS_ORDERED = "navigation_items_ordered";
export const SETTINGS_NUMBER_OF_COMPETITIVE_COLORS = "number_of_competitive_colors";
export const SETTINGS_NUMBER_OF_TABS = "number_of_tabs";
export const SETTINGS_ORDERING_ENABLED = "ordering_enabled";
export const SETTINGS_ORDER_MODAL_ENABLED = "order_modal_enabled";
export const SETTINGS_ORDER_SEARCH_ITEMS = "order_search_items";
export const SETTINGS_OVERWRITE_LAST_TAB = "overwrite_last_tab";
export const SETTINGS_PRICING_ENABLED = "pricing_enabled";
export const SETTINGS_PRICE_TYPES = "price_types";
export const SETTINGS_PRICE_VISIBILITY_TYPES = "price_visibility_types";
export const SETTINGS_PRINT_AS_IMAGE = "print_as_image";
export const SETTINGS_PRINT_AFTER_DISPENSING = "print_after_dispensing";
export const SETTINGS_PRINT_BEFORE_DISPENSING = "print_before_dispensing";
export const SETTINGS_PRINT_ENABLED = "print_enabled";
export const SETTINGS_PRINT_ON_REQUEST = "print_on_request";
export const SETTINGS_PRINT_TASKS_AFTER_DISPENSING = "print_tasks_after_dispensing";
export const SETTINGS_PRINT_TASKS_BEFORE_DISPENSING = "print_tasks_before_dispensing";
export const SETTINGS_PRINTER = "printer";
export const SETTINGS_PRINTER_TEMPLATE = "printer_template";
export const SETTINGS_PRINTER_TEMPLATE_QUICKTINT = "printer_template_quicktint";
export const SETTINGS_PRODUCT_CODE = "product_code";
export const SETTINGS_PRODUCT_FILES_SOURCE = "product_files_source";
export const SETTINGS_PRODUCT_GROUPS = "product_groups";
export const SETTINGS_PRODUCT_IMAGE_PREVIEW = "product_image_preview";
export const SETTINGS_QUALITY_CONTROL_COLOR_DIFFERENCE = "quality_control_color_difference";
export const SETTINGS_QUALITY_CONTROL_DELTA_E = "quality_control_delta_e";
export const SETTINGS_QUALITY_CONTROL_DELTA_A = "quality_control_delta_a";
export const SETTINGS_QUALITY_CONTROL_DELTA_B = "quality_control_delta_b";
export const SETTINGS_QUALITY_CONTROL_DELTA_L = "quality_control_delta_l";
export const SETTINGS_QUALITY_CONTROL_ENABLED = "quality_control_enabled";
export const SETTINGS_QUALITY_CONTROL_METAMERISM = "quality_control_metamerism";
export const SETTINGS_QUICK_TINT_SORTING_TYPE = "quick_tint_sorting_type";
export const SETTINGS_QUICK_TINT_WINDOW_CLOSING_RULES = "quick_tint_close_after_dispensing";
export const SETTINGS_RECIRCULATION_TIME = "settings_recirculation_time";
export const SETTINGS_RECIRCULATION_SPEED = "settings_recirculation_speed";
export const SETTINGS_ROUNDING = "rounding";
export const SETTINGS_SCREENSAVER_TIMEOUT = "screensaver_timeout";
export const SETTINGS_SEARCH_CHEAPER_COLORS = "search_cheaper_colors";
export const SETTINGS_SEARCH_PANEL_BASE = "search_panel_base";
export const SETTINGS_SEARCH_PANEL_BASE_SIZE = "search_panel_base_size";
export const SETTINGS_SEARCH_PANEL_BIPP = "search_panel_bipp";
export const SETTINGS_SEARCH_PANEL_BIPP_SIZE = "search_panel_bipp_size";
export const SETTINGS_SEARCH_PANEL_DROP_DOWN_CALCULATE = "search_panel_drop_down_calculate";
export const SETTINGS_SEARCH_PANEL_FANDECK_SIZE = "search_panel_fandeck_size";
export const SETTINGS_SEARCH_PANEL_FORMULA_SIZE = "search_panel_formula_size";
export const SETTINGS_SEARCH_PANEL_PRODUCT = "search_panel_product";
export const SETTINGS_SEARCH_PANEL_PRODUCT_SIZE = "search_panel_product_size";
export const SETTINGS_SEARCH_PANEL_QUICK_SELECT = "search_panel_without_confirmation";
export const SETTINGS_SEARCH_PANEL_ORDER = "search_panel_order";
export const SETTINGS_SEARCH_PANEL_ORDER_BY_DISTANCE = "search_panel_order_by_distance";
export const SETTINGS_SOUND_ENABLED = "sound_enabled";
export const SETTINGS_SPECTRO_ENABLED = "spectro_enabled";
export const SETTINGS_STIRRING_TIME = "settings_stirring_time";
export const SETTINGS_STIRRING_SPEED = "settings_stirring_speed";
export const SETTINGS_TABLE_ANSWER = "table_answer";
export const SETTINGS_TABLE_BASE = "table_base";
export const SETTINGS_TABLE_BIPP = "table_bipp";
export const SETTINGS_TABLE_BUILDING_SITE = "table_building_site";
export const SETTINGS_TABLE_CLIENT_NAME = "table_client_name";
export const SETTINGS_TABLE_COLOR_NAME = "table_color_name";
export const SETTINGS_TABLE_COMMENT = "table_comment";
export const SETTINGS_TABLE_CREATED = "table_created";
export const SETTINGS_TABLE_CUSTOMER = "table_customer";
export const SETTINGS_TABLE_DATE = "table_date";
export const SETTINGS_TABLE_FANDECK = "table_fandeck";
export const SETTINGS_TABLE_FORMULA_CODE = "table_formula_code";
export const SETTINGS_TABLE_FORMULA_NAME = "table_formula_name";
export const SETTINGS_TABLE_MORE_INFO = "table_more_info";
export const SETTINGS_TABLE_MORE_INFO_INTERNAL = "table_more_info_internal";
export const SETTINGS_TABLE_OPERATOR = "table_operator";
export const SETTINGS_TABLE_PACKAGE = "table_package";
export const SETTINGS_TABLE_PRODUCT = "table_product";
export const SETTINGS_TABLE_QUALITY_CONTROL = "table_quality_control";
export const SETTINGS_TABLE_QUANTITY = "table_quantity";
export const SETTINGS_TABLE_STATUS = "table_status";
export const SETTINGS_TABLE_SUBJECT = "table_subject";
export const SETTINGS_TABLE_TICKET_ID = "table_ticket_id";
export const SETTINGS_TABLE_TYPE = "table_type";
export const SETTINGS_TABS_ENABLED = "tabs_enabled";
export const SETTINGS_TABS_MEMORY = "tabs_memory";
export const SETTINGS_TINTOMETRIC_SYSTEM = "tintometric_system";
export const SETTINGS_UFI_CODE_BASE_VALIDATION = "ufi_code_base_validation";
export const SETTINGS_UFI_CODE_LOGIC = "ufi_code_logic";
export const SETTINGS_UFI_CODE_MIN_AMOUNT_GRAV_PERCENT = "ufi_code_min_amont_grav_percent";
export const SETTINGS_UFI_CODE_MIN_GRAV_PERCENT = "ufi_code_min_grav_percent";
export const SETTINGS_USER_IDENTIFICATION_ENABLED = "user_identification";
export const SETTINGS_VALIDATE_MIN_DOSABLE_AMOUNT = "check_min_dosable_amount";
export const SETTINGS_VALIDATE_COLORANT_BASE_RULES = "check_colorant_base_rules";
export const SETTINGS_VALIDATE_OVERFILL = "check_overfill";
export const SETTINGS_VALIDATE_TOTAL_CNT_AMOUNTS = "check_total_cnt_amounts";
export const SETTINGS_VIRTUAL_KEYBOARD_ENABLED = "virtual_keyboard_enabled";
export const SETTINGS_VISIBLE_UNITS = "visible_units";
export const SETTINGS_ZOOM = "zoom";

// Price settings items
export const PRICE_SETTINGS_LOCAL_PRICES = "enable_local_prices";
export const PRICE_SETTINGS_PRICE_DEFINITION = "price_definition";
export const PRICE_SETTINGS_PRICE_UNIT_DEFINITION = "price_unit_definition";
export const PRICE_SETTINGS_PRICE_GROUP_NUMBER = "num_price_groups";
export const PRICE_SETTINGS_PRICE_GROUPS = "enable_price_groups";
export const PRICE_SETTINGS_USE_MARGIN = "use_margin";
export const PRICE_SETTINGS_USE_MARKUP = "use_markup";
export const PRICE_SETTINGS_USE_DISCOUNT = "use_discount";

// Software functions
export const FUNCTION_ADD_CANISTER_LEVEL = "function_add_canister_level";
export const FUNCTION_AUTOMATIC_CORRECTION = "function_automatic_correction";
export const FUNCTION_BACKUP_MACHINE_CONFIGURATION = "function_backup_machine_configuration";
export const FUNCTION_CLOSE_REDLIKE = "function_close_redlike";
export const FUNCTION_COMPETITIVE_COLOR_SEARCH = "function_competitive_color_search";
export const FUNCTION_CREATE_TEMPLATE = "function_create_template";
export const FUNCTION_DELETE_ORDER = "function_delete_order";
export const FUNCTION_DELETE_TICKET = "function_delete_ticket";
export const FUNCTION_DISCONNECT_SERVER = "function_disconnect_server";
export const FUNCTION_DISPENSING = "function_dispensing";
export const FUNCTION_EDIT_TEMPLATE = "function_edit_template";
export const FUNCTION_EXPORT_COLORANT_CONSUMPTION = "function_export_colorant_consumption";
export const FUNCTION_EXPORT_HISTORY = "function_export_history";
export const FUNCTION_EXPORT_PRINT_LABEL_TO_IMG = "function_export_print_label_to_img";
export const FUNCTION_EXPORT_PRINT_LABEL_TO_PDF = "function_export_print_label_to_pdf";
export const FUNCTION_EXPORT_PRODUCT_FILE_TO_PDF = "function_export_product_file_to_pdf";
export const FUNCTION_FILL_CANISTER_TO_MAX = "function_fill_canister_to_max";
export const FUNCTION_FIND_IN_SETTINGS = "function_find_in_settings";
export const FUNCTION_LOG_OUT = "function_log_out";
export const FUNCTION_MANUAL_CORRECTION = "function_manual_correction";
export const FUNCTION_MODIFY_USER = "function_modify_user";
export const FUNCTION_OPEN_BROWSER = "function_open_browser";
export const FUNCTION_ORDER = "function_order";
export const FUNCTION_PRINT = "function_print";
export const FUNCTION_REACTIVATE_LICENSE = "function_reactivate_license";
export const FUNCTION_REBOOT_PC = "function_reboot_pc";
export const FUNCTION_REFILL_BY_COLORANT_PACKAGE = "function_refill_by_colorant_package";
export const FUNCTION_REFORMULATE = "function_reformulate";
export const FUNCTION_RESET_FORMULA_TAB = "function_reset_formula_tab";
export const FUNCTION_RESTART_REDLIKE = "function_restart_redlike";
export const FUNCTION_RESTART_SERVER = "function_restart_server";
export const FUNCTION_RETINT = "function_retint";
export const FUNCTION_SAVE_TO_HISTORY = "function_save_to_history";
export const FUNCTION_SEARCH_CUSTOM_FORMULAS = "function_search_custom_formulas";
export const FUNCTION_SET_CANISTER_BARCODE = "function_set_canister_barcode";
export const FUNCTION_SET_CANISTER_DISPENSE_LOGIC = "function_set_canister_dispense_logic";
export const FUNCTION_SET_CANISTER_LEVEL = "function_set_canister_level";
export const FUNCTION_SET_CANISTER_UFI_CODE = "function_set_canister_ufi_code";
export const FUNCTION_SET_MAX_CANISTER_DISPENSE_AMOUNT = "function_set_max_canister_dispense_amount";
export const FUNCTION_SHUTDOWN_PC = "function_shutdown_pc";
export const FUNCTION_SPECTRO_CALIBRATE = "function_spectro_calibrate";
export const FUNCTION_SPECTRO_MEASURE = "function_spectro_measure";
export const FUNCTION_SWITCH_TO_INTERGAMMA = "function_switch_to_intergamma";
export const FUNCTION_SWITCH_TO_LIGHT = "function_switch_to_light";
export const FUNCTION_SWITCH_TO_REDLIKE = "function_switch_to_redlike";
export const FUNCTION_TRIGGER_REFILL_DIALOG = "function_trigger_refill_dialog";
export const FUNCTION_VALIDATE_ORDER_PACKAGE = "function_validate_order_package";
export const FUNCTION_CHANGE_USER = "function_change_user";

//Machine settings
export const MACHINE_SETTINGS_CHECK_CAN_BEFORE_DISPENSING = "machine_setting_check_can_before_dispensing";
export const MACHINE_SETTINGS_CHECK_OVERFILL = "machine_settings_check_overfill";
export const MACHINE_SETTINGS_DISPENSE_INVALID_COLORANTS = "machine_setting_dispense_invalid_colorants";
export const MACHINE_SETTINGS_ENABLE_TMC = "machine_settings_enable_tmc";
export const MACHINE_SETTINGS_MACHINE_UNIT = "machine_setting_machine_unit";
export const MACHINE_SETTINGS_MANUAL_ADDITION = "machine_settings_manual_addition";
export const MACHINE_SETTINGS_MINIMAL_DISPENSE_AMOUNT = "machine_settings_minimal_dispense_amount";
export const MACHINE_SETTINGS_PLACE_CAN_SENZOR = "machine_setting_place_can_senzor";
export const MACHINE_SETTINGS_PLACE_CAN_SENZOR_DELAY = "machine_setting_place_can_senzor_delay";
export const MACHINE_SETTINGS_REMOVE_CAN_SENZOR = "machine_setting_remove_can_senzor";
export const MACHINE_SETTINGS_REMOVE_CAN_SENZOR_DELAY = "machine_setting_remove_can_senzor_delay";
export const MACHINE_SETTINGS_SKIP_PLACE_CAN_DIALOG = "machine_settings_skip_place_can_dialog";
export const MACHINE_SETTINGS_SKIP_REMOVE_CAN_DIALOG = "machine_settings_skip_remove_can_dialog";
export const MACHINE_SETTINGS_SPLIT_FORMULA = "machine_settings_split_formula";
export const MACHINE_SETTINGS_VALIDATE_BARCODE_CAN = "machine_settings_validate_barcode_can";
export const MACHINE_SETTINGS_VALIDATE_BARCODE_REFILL = "machine_setting_barcode_refill";
export const MACHINE_SETTINGS_VALIDATE_COLORANTS_DURING_INIT = "machine_settings_validate_colorants_during_init";

// Machine service actions
export const MACHINE_ACTION_INITIALIZE = "machine_action_initialize";
export const MACHINE_ACTION_RESET = "machine_action_reset";
export const MACHINE_ACTION_HARD_RESET = "machine_action_hard_reset";
export const MACHINE_ACTION_ERROR_RESET = "machine_action_error_reset";
export const MACHINE_ACTION_SHOW_SERVICE_WINDOW = "machine_action_show_service_window";
export const MACHINE_ACTION_DISCONNECT = "machine_action_disconnect";
export const MACHINE_ACTION_PURGE = "machine_action_purge";
export const MACHINE_ACTION_PURGE_ALL = "machine_action_purge_all";
export const MACHINE_ACTION_SMART_PURGE = "machine_action_smart_purge";
export const MACHINE_ACTION_SMART_PURGE_ALL = "machine_action_smart_purge_all";
export const MACHINE_ACTION_CLEAN_CHANNELS = "machine_action_clean_channels";
export const MACHINE_ACTION_CLEAN_ALL_CHANNELS = "machine_action_clean_all_channels";
export const MACHINE_ACTION_RECIRCULATE_CHANNELS = "machine_action_recirculate_channels";
export const MACHINE_ACTION_RECIRCULATE_ALL_CHANNELS = "machine_action_recirculate_all_channels";
export const MACHINE_ACTION_STIR_CANISTERS = "machine_action_stir_canisters";
export const MACHINE_ACTION_STIR_ALL_CANISTERS = "machine_action_stir_all_canisters";
export const MACHINE_ACTION_CAP_OPEN = "machine_action_cap_open";
export const MACHINE_ACTION_CAP_CLOSE = "machine_cap_close";
export const MACHINE_ACTION_SHELF_UP = "machine_action_shelf_up";
export const MACHINE_ACTION_SHELF_DOWN = "machine_action_shelf_down";
export const MACHINE_ACTION_PUNCH = "machine_action_punch";
export const MACHINE_ACTION_PLUG = "machine_action_plug";

// basic setup components
export const SETUP_DATABASE = "setup_database";
export const SETUP_ENVIRONMENT = "setup_environment";
export const SETUP_ENVIRONMENT_FORMULA = "setup_environment_formula";
export const SETUP_ENVIRONMENT_FORMULA_DATA = "setup_environment_formula_data";
export const SETUP_ENVIRONMENT_IMPORT = "setup_environment_import";
export const SETUP_ENVIRONMENT_LAYOUT = "setup_environment_layout";
export const SETUP_ENVIRONMENT_NAVIGATION = "setup_environment_navigation";
export const SETUP_ENVIRONMENT_UPDATE = "setup_environment_update";
export const SETUP_LANGUAGE = "setup_language";
export const SETUP_LICENSE = "setup_license";
export const SETUP_LOGIN = "setup_login";
export const SETUP_MACHINE = "setup_machine";
export const SETUP_MACHINE_DRIVER = "setup_machine_driver";
export const SETUP_MACHINE_SETTINGS = "setup_machine_settings";
export const SETUP_PRINTER = "setup_printer";
export const SETUP_PRINTER_OPTIONS = "setup_printer_options";
export const SETUP_PRINTER_SETTINGS = "setup_printer_settings";
export const SETUP_PRINTER_TEMPLATE_SETTINGS = "setup_printer_template_settings";
export const SETUP_SPECTRO = "setup_spectro";
